import React from 'react';
import PropTypes from 'prop-types';
import BookingStatsList from './BookingStatsList';
import Header from 'components/ui/general/Header';
import Title from 'components/ui/general/Title';
import filterMatchTypes from 'components/list/Filters/filterMatchTypes';
import translate from 'components/hoc/translate';
import { ORDER_BY_DAY } from 'store/reducers/bookingStatsReducer';

const BookingStatsListContainer = (props, context) => {
    const {
        config: {
            currency: {
                system,
            },
        },
    } = context;

    const {
        translate,
    } = props;

    const initialFilters = {
        is_test_order: {
            matchType: filterMatchTypes.equals,
            value: '0',
        },
        interval: {
            matchType: filterMatchTypes.matchOneOf,
            value: ORDER_BY_DAY,
        },
        reservation_status: {
            matchType: filterMatchTypes.matchOneOf,
            value: [
                'completed',
            ],
        },
        currencies: {
            matchType: filterMatchTypes.matchOneOf,
            value: [
                system,
            ],
        },
    };

    return (
        <div>
            <Header>
                <Title title={ translate('resources.bookingStats.title') } />
            </Header>

            <BookingStatsList
                { ...props }
                initialFilters={ initialFilters }
            />
        </div>
    );
};

BookingStatsListContainer.contextTypes = {
    config: PropTypes.object,
};

BookingStatsListContainer.propTypes = {
    translate: PropTypes.func.isRequired,
};

export default translate(BookingStatsListContainer);



// WEBPACK FOOTER //
// ./src/pages/bookingStats/list/BookingStatsListContainer.js